<template>
  <div class="addMedicoBox mb-2">
    <div class="addMedicoBox_header mb-3"
         :class="{'addMedicoBox_header_error': errors_general }">
      <div class="row no-gutters align-items-center justify-content-between">
        <div class="col">
          <div class="">
            <h2 class="addMedicoBox_header_title">
              Médico
              <span v-if="errors_general">
                <IconSvg class="icon-error-campo"
                         icon="alert" />
                Há campos incorretos
              </span>
            </h2>
          </div>
        </div>
      </div>
    </div>

    <div class="addMedicoBox_body">
      <BoxMedicos v-for="(med, index) in listaMedicos"
                  :key="index"
                  :prop-index="index"
                  :medico="med"
                  :prop-correcoes="propCorrecoes"
                  @edit="edit(med, index)"
                  @remove="remove" />

      <div class="col-12 m-0 p-0">
        <button id="btn-add-medico"
                v-b-modal.addMedico
                class="btn btn-add-medico btn-sm btn-outline-primary btn-block m-0 mb-3"
                type="button">
          <IconSvg class="icon-add icon--sm mr-1"
                   icon="add" />
          Adicionar médico
        </button>
      </div>
    </div>

    <b-modal id="addMedico"
             ref="modalAddMedico"
             modal-class="modalAddMedico"
             body-class="modalAddMedico_body"
             :hide-header="true"
             centered
             size="xl"
             no-close-on-backdrop
             no-close-on-esc
             @ok="modalChanged"
             @hide="modalChanged">
      <div class="mt-3">
        <FormAddMedico :medico="medico"
                       @changed="change" />
      </div>

      <div slot="modal-footer"
           slot-scope="{ ok, cancel }"
           class="modalAddMedico_footer">
        <button class="btn btn-sm btn-dark mr-2"
                @click="cancel()">
          Voltar
        </button>
        <button class="btn btn-sm btn-primary"
                type="button"
                :disabled="!medico.nome || !medico.crm"
                @click="addMedico">
          Continuar
        </button>
      </div>
    </b-modal>

    <b-modal id="editMedico"
             ref="modalEditMedico"
             modal-class="modalEditMedico"
             body-class="modalEditMedico_body"
             :hide-header="true"
             centered
             size="xl"
             no-close-on-backdrop
             no-close-on-esc
             @ok="modalChanged"
             @hide="modalChanged">
      <div class="mt-3">
        <FormAddMedico :medico="editMedico"
                       @changed="changeEdit" />
      </div>

      <div slot="modal-footer"
           slot-scope="{ ok, cancel }"
           class="modalEditMedico_footer">
        <button class="btn btn-sm btn-dark mr-2"
                @click="cancel()">
          Voltar
        </button>
        <button class="btn btn-sm btn-primary"
                type="button"
                @click="updateMedico">
          Atualizar
        </button>
      </div>
    </b-modal>
  </div>
</template>

<script>
  /* components */
  import FormAddMedico from '@/components/SofiaRei/Obito/Forms/FormAddMedico.vue'
  import BoxMedicos from '@/components/SofiaRei/Obito/BoxMedicos.vue'

  /* services */
  import MedicosService from "@/services/Registros/Obito/MedicosService"


  export default {
    name: 'Medicos',
    components: { FormAddMedico, BoxMedicos },
    inject: ['$validator'],
    props: {
      listaMedicos: { type: Array, default: () => [] },
      readOnly: { type: Boolean, default: () => false },
      propCorrecoes: {type: Object, default: () => ({})}
    },
    data () {
      return {
        medico: { legista: 0 },
        editMedico: {},
        errors_general: false,
        errors_medico_one: false,
        errors_medico_two: false,
      }
    },
    watch: {
      propCorrecoes () {
        this.verifyErrorsCarga()
      }
    },
    mounted () {
      this.verifyErrorsCarga()
    },
    methods: {

      modalChanged () {
        this.medico = {nome: null, crm: null, uf: null, legista: 0}
      },

      change (data) {
        this.medico = data
      },

      changeEdit (data) {
        this.editMedico = data
      },

      async addMedico () {
        this.upperName()
        try {
          const medico = !this.readOnly ? await MedicosService.storeMedicos(this.$route.params.id, this.medico) : this.medico
          this.$validator.validateAll()

          if (this.listaMedicos.length == 0) this.deleteError(['ATESTANTE PRIMÁRIO'])

          this.listaMedicos.push(medico)
          this.medico = {}
          this.$refs.modalAddMedico.hide()
          objSwal.success.title = "Cadastrado com Sucesso"
          objSwal.success.text = ''

          setTimeout(() => {
            const btnConfirm = document.querySelector('.swal2-confirm')

            if (btnConfirm) btnConfirm.focus()
          }, 300)

          Swal.fire(objSwal.success).then(() => {
            const btnAdd = document.querySelector('.btn-add-medico')

            if (btnAdd) btnAdd.focus()
          })
        } catch (err) {
          objSwal.error.title = 'Erro ao cadastrar Médico'
          objSwal.error.text = err.message

          setTimeout(() => {
            const btnConfirm = document.querySelector('.swal2-confirm')

            if (btnConfirm) btnConfirm.focus()
          }, 300)

          return Swal.fire(objSwal.error).then(() => {
            const btnAdd = document.querySelector('.btn-add-medico')

            if (btnAdd) btnAdd.focus()
          })
        }
      },

      async updateMedico () {
        try {
          if (!this.readOnly) {
            await MedicosService.updateMedico(this.editMedico.medico_id, { ...this.editMedico })
          }
          this.$validator.validateAll()

          this.filterError(this.editMedico.localId)

          this.upperName()
          this.$emit('medicoUpdated', this.editMedico, this.editMedico.localId)
          this.$refs.modalEditMedico.hide()
          objSwal.success.title = "Atualizado com Sucesso"
          objSwal.success.text = ''

          setTimeout(() => {
            const btnConfirm = document.querySelector('.swal2-confirm')

            if (btnConfirm) btnConfirm.focus()
          }, 300)

          Swal.fire(objSwal.success).then(() => {
            const btnAdd = document.querySelector('.btn-add-medico')

            if (btnAdd) btnAdd.focus()
          })
        } catch (err) {
          objSwal.error.title = 'Erro ao atualizar Médico'
          objSwal.error.text = err.message

          setTimeout(() => {
            const btnConfirm = document.querySelector('.swal2-confirm')

            if (btnConfirm) btnConfirm.focus()
          }, 300)

          return Swal.fire(objSwal.error).then(() => {
            const btnAdd = document.querySelector('.btn-add-medico')

            if (btnAdd) btnAdd.focus()
          })
        }
      },
      upperName () {
        if (this.medico.nome) {
          this.medico.nome = this.medico.nome.toUpperCase()
        }
        if (this.editMedico.nome) {
          this.editMedico.nome = this.editMedico.nome.toUpperCase()
        }
      },

      edit (medico, localId) {
        this.editMedico = Object.assign({}, medico)
        this.editMedico.localId = localId
        this.$refs.modalEditMedico.show()
      },

      async remove (medico) {
        if (!this.readOnly) {
          await MedicosService.deleteMedico(medico.medico_id)
        }

        const index = this.listaMedicos.findIndex(med => med == medico)

        this.filterError (index)

        this.$emit('medicoRemoved', medico)
        objSwal.success.title = "Removido com Sucesso"
        objSwal.success.text = ''

        setTimeout(() => {
          const btnConfirm = document.querySelector('.swal2-confirm')

          if (btnConfirm) btnConfirm.focus()
        }, 300)

        Swal.fire(objSwal.success).then(() => {
          const btnAdd = document.querySelector('.btn-add-medico')

          if (btnAdd) btnAdd.focus()
        })
      },

      deleteError (error) {
        this.$emit('deleteError', error)
      },

      filterError (index) {
        if (index > 1) return

        if (this.errors_medico_one && this.errors_medico_two) this.deleteError(['SEGUNDO MÉDICO', 'ATESTANTE SECUNDÁRIO'])
        else if (this.errors_medico_one && !this.errors_medico_two) this.deleteError(['NOME DO MÉDICO', 'ATESTANTE PRIMÁRIO'])
        else if (!this.errors_medico_one && this.errors_medico_two) this.deleteError(['SEGUNDO MÉDICO', 'ATESTANTE SECUNDÁRIO'])
      },
      verifyErrorsCarga () {
        this.errors_general = false
        this.errors_medico_one = false
        this.errors_medico_two  = false

        const errors = [
          'MÉDICO',
          'ATESTANTE PRIMÁRIO',
          'ATESTANTE SECUNDÁRIO',
          'SEGUNDO MÉDICO',
          'PRIMEIRO MÉDICO',
          'NOME DO MÉDICO'
        ]

        Object.keys(this.propCorrecoes).forEach(key => {
          if (errors.indexOf(key) != -1) this.errors_general = true

          if (['NOME DO MÉDICO', 'ATESTANTE PRIMÁRIO'].indexOf(key) != -1) this.errors_medico_one = true

          if (['SEGUNDO MÉDICO', 'ATESTANTE SECUNDÁRIO'].indexOf(key) != -1) this.errors_medico_two = true
        })
      }
    },
  }
</script>

<style lang="scss">
  @import '../../../../../scss/_utilities/_exports';

  .addMedicoBox {
    &_header {
      @extend %titleBox;
      background-color: $color-gray-light;

      &_title {
        @extend %titleBox_title;
      }

      &_error {
        color: #8B0000;
      }
    }
  }

  .modalAddMedico {
    &_body {
      border-bottom: pxToRem(1) solid $sinoreg-blue;
      margin: 0 pxToRem(20);
      padding: 0;
    }

    &_footer {
      border: none;
    }

    .modal-footer {
      border: none;
    }
  }

  .btn-add-medico:hover > [class*=icon-add] {
    fill: #fff !important;
  }
  .icon-add {
    fill: #1c7af5 !important;
    width: 16px;
    height: 16px;
    transition: fill 0.2s;
  }
</style>
